import React, { useEffect, useState } from "react";
import { Controller, SubmitHandler, useForm } from "react-hook-form";
import { Button, Header, Input, TextArea, TypeButton } from "../../components";
import { isEmpty, useAppDispatch } from "../../utils";
import { PROVINCE } from "../../constants/_province";
import { CITY_DISTRICT } from "../../constants/_city_and_district";
import { IFarmerStore } from "../../redux/FarmerStore/farmerStore.types";
import { storeFarmerStore } from "../../redux/FarmerStore/farmerStore.actions";
import { useNavigate } from "react-router-dom";
import { ROUTE } from "../../constants";
import Select from "react-select";

const NewFarmerShop: React.FC = () => {
  const navigate = useNavigate();
  const dispatch = useAppDispatch();

  const {
    register,
    handleSubmit,
    formState: { errors },
    setValue,
  } = useForm<IFarmerStore>();

  interface IDropdown {
    label: string | number;
    value: string | number;
  }

  type FormData = {
    province: IDropdown | null;
    city_or_district: IDropdown | null;
  };

  const { control: DropdownControl, watch: watchDropdown } =
    useForm<FormData>();

  const [listProvince, setListProvince] = useState<IDropdown[]>([]);
  const [listCity, setListCity] = useState<IDropdown[]>([]);

  useEffect(() => {
    setListProvince(PROVINCE);
  }, []);

  const addNewFarmerShop: SubmitHandler<IFarmerStore> = async (data) => {
    await dispatch(storeFarmerStore(data));
    navigate(ROUTE.FARMER_SHOPS);
  };

  const province = watchDropdown("province");
  const city_or_district = watchDropdown("city_or_district");

  useEffect(() => {
    if (!isEmpty(province)) {
      setValue("province", province?.value as string);
      const cityByProvince = CITY_DISTRICT.filter(
        (val) => (val.province_id as string) === (province?.value as string)
      );
      setListCity(cityByProvince);
    }
    if (!isEmpty(city_or_district)) {
      setValue("city_or_district", city_or_district?.value as string);
    }
  }, [province, city_or_district, setValue]);

  return (
    <div className="px-5">
      <div className="mt-4" />
      <Header title={`Tambah Toko`} />
      <form onSubmit={handleSubmit(addNewFarmerShop)}>
        {/* Address */}
        <Input
          errorMessage={errors.name?.message as string}
          id="name"
          isError={!isEmpty(errors.name)}
          labelTop="Nama Toko"
          register={register("name", {
            required: "Nama Toko wajib diisi",
          })}
        />
        <TextArea
          errorMessage={errors.address?.message as string}
          id="address"
          isError={!isEmpty(errors.address)}
          labelTop="Alamat Lengkap"
          styleWrapper="mt-6"
          register={register("address", {
            required: "Alamat wajib diisi",
          })}
        />
        <div className={`flex flex-col gap-2 mt-6`}>
          <label className="text-[16px] font-bold">Provinsi</label>
          <Controller
            name="province"
            control={DropdownControl}
            render={({ field }) => (
              <Select
                {...field}
                options={listProvince}
                isSearchable={true}
                placeholder="Pilih Provinsi"
                className="w-full rounded-md text-lg bg-white border-[#CCC]"
                value={{ label: field.value?.label }}
              />
            )}
          />
        </div>
        <input {...register("province", { required: true })} hidden />

        <div className={`flex flex-col gap-2 mt-6`}>
          <label className="text-[16px] font-bold">Kota</label>
          <Controller
            name="city_or_district"
            control={DropdownControl}
            render={({ field }) => (
              <Select
                {...field}
                options={listCity}
                isSearchable={true}
                placeholder="Pilih Kota"
                className="w-full rounded-md text-lg bg-white border-[#CCC]"
                value={{ label: field.value?.label }}
              />
            )}
          />
        </div>
        <input {...register("city_or_district", { required: true })} hidden />

        {/* Contact */}
        <h1 className="font-bold text-xl text-[#333] my-12">Kontak</h1>
        <Input
          errorMessage={errors.owner_name?.message as string}
          id="owner-name"
          isError={!isEmpty(errors.owner_name)}
          labelTop="Nama"
          register={register("owner_name", {
            required: "Nama Wajib Diisi",
          })}
          styleWrapper="mt-0"
        />
        <Input
          errorMessage={errors.phone?.message as string}
          id="phone"
          isError={!isEmpty(errors.phone)}
          labelTop="No. HP / WA"
          register={register("phone", {
            required: "Nomor HP/WA Wajib Diisi",
          })}
          styleWrapper="mt-6"
        />

        <Button type={TypeButton.submit} title="Simpan" className="my-12" />
      </form>
    </div>
  );
};

export default NewFarmerShop;
